import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

export const segmentTrack = (
  name,
  quiz_version,
  token,
  question_id,
  question,
  section_id,
  section_name
) => {
  segmentEvent(name, {
    quiz_version,
    token,
    question_id,
    question,
    section_id,
    section_name,
  })
}

export const formattedSectionName = (name) => {
  if (name === "hormones-men" || name === "hormone") {
    return "hormones"
  }
  return name
}

// TODO: make this dynamic
export const sectionNameToId = (name) => {
  if (name === "hormones-men") {
    return "7c873e2b-d169-497f-9fb9-8ef5cf714d76"
  } else if (name === "hormone") {
    return "7d873e2b-d169-497f-9fb9-8ef5cf714d76"
  } else if (name === "stress") {
    return "7d872e2b-d169-497f-9fb9-8ef5cf714d76"
  } else if (name === "metabolism") {
    return "7d872e2b-d164-497f-9fb9-8ef5cf714d76"
  } else if (name === "nutrition") {
    return "7d872e2b-d164-497f-9fb9-8ef5cf714d78"
  } else if (name === "lifestyle") {
    return "7d872e2b-d164-497f-9fb9-8ef5cf7876ag"
  } else if (name === "aging") {
    return "7d872e2b-d164-497f-9fb9-8ef5cf714d77"
  } else if (name === "basics") {
    return "2"
  } else if (name === "intro") {
    return "1"
  }
  return 0
}

export const sectionNameToNum = (name) => {
  if (name === "hormones-men") {
    return 1
  } else if (name === "hormone") {
    return 2
  } else if (name === "stress") {
    return 3
  } else if (name === "lifestyle") {
    return 4
  } else if (name === "metabolism") {
    return 5
  } else if (name === "nutrition") {
    return 6
  } else if (name === "aging") {
    return 7
  } else if (name === "basics") {
    return 0
  } else if (name === "basics") {
    return 0
  } else if (name === "intro") {
    return "intro"
  }
  return "basics"
}

export const formatGenderText = (text) => {
  if (!!text) {
    if (text.includes("Women")) {
      return "female"
    }
    return "male"
  }
  return null
}

// can handle gender object from redux or actual string
export const formatGender = (unformattedGender) => {
  if (
    typeof unformattedGender === "object" &&
    unformattedGender !== null &&
    !!unformattedGender.globalid
  ) {
    return unformattedGender.globalid.indexOf("women") > -1 ? "female" : "male"
  }
  return unformattedGender
}

// can handle age object from redux or actual string
export const formatAge = (unformattedAge) => {
  if (
    typeof unformattedAge === "object" &&
    unformattedAge !== null &&
    !!unformattedAge.text
  ) {
    return unformattedAge.text
  }
  return unformattedAge
}

export const addToCartEvent = (
  products_array,
  quiz_results_id,
  quiz_results_url,
  variant_name,
  page_url
) => {
  return segmentEvent("Quiz Added Recommendation", {
    experiment_description:
      "Tracking the number of users who have added products to cart from quiz results page for A/B test to track a funnel report/correlate those views with primary and secondary metrics",
    products_array: [products_array],
    quiz_results_id: quiz_results_id,
    quiz_results_url: quiz_results_url,
    variant_name: variant_name,
    page_url: page_url,
  })
}

export const modalTabViewedEvent = (name) => {
  return segmentEvent("Modal Tab Viewed", {
    name: name,
    page_title: "Your Results - Nutrafol Hair Wellness Examination",
    page_url: window.location.href,
  })
}
